import React from 'react';

import Grid, { Col } from 'Components/Grid';
import SocialIcons, { SocialIconsProps } from 'Components/SocialIcons';

import { Container, Heading, HeadingContainer, SocialWrapper, Wave, Icon } from './Socials.styled';
import Arrow, { ArrowButtonProps } from 'Elements/Button/Arrow';

export interface Props {
    icon?: React.ElementType;
    heading: string | React.ReactNode;
    headingType?: 'h2' | 'h3';
    text: string;
    socialIcons?: SocialIconsProps;
    isTabletHalfWidthCard?: boolean;
    backgroundColour?: React.CSSProperties['color'];
    link?: ArrowButtonProps;
    className?: string;
}

const Socials: React.FC<Props> = props => {
    const {
        heading,
        headingType = 'h2',
        text,
        socialIcons,
        isTabletHalfWidthCard = false,
        backgroundColour,
        icon,
        link,
        className
    } = props;

    return (
        <Container
            style={
                {
                    '--bg-promo-socials': backgroundColour
                } as React.CSSProperties
            }
            className={className}
        >
            <Grid>
                <Col l={isTabletHalfWidthCard ? 12 : [3, 11]} textAlign="center">
                    <HeadingContainer>
                        {icon && <Icon as={icon} />}
                        {typeof heading === 'string' ? (
                            <Heading
                                as={headingType}
                                $isTabletHalfWidthCard={isTabletHalfWidthCard}
                            >
                                {heading}
                            </Heading>
                        ) : (
                            heading
                        )}
                    </HeadingContainer>
                    <p>{text}</p>
                    <SocialWrapper>
                        {link && <Arrow {...link} />}
                        {socialIcons && <SocialIcons {...socialIcons} />}
                    </SocialWrapper>
                </Col>
            </Grid>
            <Wave $isTabletHalfWidthCard={isTabletHalfWidthCard} />
        </Container>
    );
};

export default Socials;
